import { action } from "satcheljs";

const resetTeamStore = action(
    "resetTeamStore", () => ({})
);

export default resetTeamStore;
